import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTenantCreditCards } from '../creditCard/creditCardQueries';
import { NonCashBenefit, useNonCashBenefitAmounts } from './const';
import { NonCashBenefitConfig } from './NonCashOption';

export const useNonCashBenefitConfig = () => {
  const { employeeId } = useParams();
  const { tenant } = useTenant();
  const { isValid, isLoading } = useNonCashBenefitAmounts();

  const { data: activeCreditCards, isFetched } = useTenantCreditCards(
    { employeeId, status: ['ACTIVE'] },
    { enabled: !!tenant?.activeBenefits?.includes(BenefitDTOBenefitEnum.CreditCard) && !!employeeId },
  );

  const isValidCreditCard = useCallback(
    () => (isFetched && employeeId ? !!activeCreditCards?.results?.length : true),
    [isFetched, employeeId, activeCreditCards?.results?.length],
  );

  const config = useMemo<Record<NonCashBenefit, NonCashBenefitConfig>>(
    () => ({
      [NonCashBenefit.Coupons]: { isValidValue: amount => isValid(NonCashBenefit.Coupons, amount) },
      [NonCashBenefit.Fitness]: { isValidValue: amount => isValid(NonCashBenefit.Fitness, amount) },
      [NonCashBenefit.CreditCard]: { isValidValue: isValidCreditCard },
      [NonCashBenefit.Wellpass]: { isValidValue: amount => isValid(NonCashBenefit.Wellpass, amount) },
    }),
    [isValid, isValidCreditCard],
  );

  return { config, isLoading };
};
